import OfficeBuilding from 'mdi-material-ui/OfficeBuilding';
import SectionCard from '../components/SectionCard';
import useMsftReferral from '../hooks/useMsftReferral';
import DetailsGrid from '../../../components/DetailsGrid/DetailsGrid';
import { formatAddress, formatFullName } from '../utils/comboFormatting';

const CustomerDetailsSection = ({ tackleId }: { tackleId: string }) => {
  const { data: referral } = useMsftReferral({ tackleId });
  const customerProfile = referral?.customerProfile ?? {};
  const contact = customerProfile?.team?.[0] ?? {};

  const dataRows: { content: React.ReactNode; title: string }[][] = [
    [
      {
        title: 'Company name',
        content: customerProfile.name,
      },
    ],
    [
      {
        title: 'Location',
        content: formatAddress(customerProfile.address),
      },
    ],
    [
      {
        title: 'Microsoft account ID',
        content: customerProfile.ids[0]?.id,
      },
      {
        title: 'MACC eligiblity',
        content: customerProfile.isMaccEligible ? 'Yes' : 'No',
      },
      // added to take up space
      { title: '', content: '' },
    ],
    [
      {
        title: 'Contact',
        content: formatFullName(contact),
      },
      {
        title: 'Email',
        content: contact.email,
      },
      {
        title: 'Phone',
        content: contact.phoneNumber,
      },
    ],
  ];

  return (
    <SectionCard
      icon={
        <OfficeBuilding
          data-testid="office-building-icon"
          style={{ fill: '#253858' }}
        />
      }
      title="Customer Details"
      bodyStyle={{ paddingBlock: '0', paddingBottom: '1.5rem' }}
    >
      <DetailsGrid>
        {dataRows.map((row, index) => (
          <DetailsGrid.Row key={index}>
            {row.map(({ title, content }, i) => (
              <DetailsGrid.Detail key={`${title}${i}`} title={title}>
                {content ?? ' - '}
              </DetailsGrid.Detail>
            ))}
          </DetailsGrid.Row>
        ))}
      </DetailsGrid>
    </SectionCard>
  );
};

export default CustomerDetailsSection;
